import {
    INDEX_PAYMENT_REPORT_REPORT,
    INDEX_PAYMENT_REPORT_REPORT_SUCCESS,
    INDEX_PAYMENT_REPORT_REPORT_ERROR,
    INDEX_PAYMENT_REPORT_SEARCH_SET,
    INDEX_PAYMENT_REPORT_SEARCH_CHANGE,
    INDEX_PAYMENT_REPORT_TAB_SET,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR,
    INDEX_PAYMENT_REPORT_DESTINATION,
    INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS,
    INDEX_PAYMENT_REPORT_DESTINATION_ERROR,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    viewtab: {
        tab: '1',
        modal: false
    },
    listreport: {
        loading: false,
        data: []
    },
    regularizationigss: {
        loading: false,
        data: []
    },
    regularizationigsspdf: {
        loading: false,
        data: []
    },
    destination: {
        loading: false,
        data: []
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            start_date_idx1: '',
            end_date_idx1: '',
            destination:''
        },
        value: {
            start_date_idx1: '',
            end_date_idx1: '',
            destination: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INDEX_PAYMENT_REPORT_REPORT:
            return {
                ...state,
                loading: true,
                listreport: {
                    ...state.listreport
                }
            }
        case INDEX_PAYMENT_REPORT_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                listreport: {
                    ...state.listreport,
                    ...action.payload
                }
            }
        case INDEX_PAYMENT_REPORT_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case INDEX_PAYMENT_REPORT_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case INDEX_PAYMENT_REPORT_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case INDEX_PAYMENT_REPORT_TAB_SET:
            return {
                ...state,
                viewtab: {
                    ...state.viewtab,
                    tab: action.payload
                }
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS:
            return {
                ...state,
                loading: true,
                regularizationigss: {
                    ...state.regularizationigss
                }
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS:
            return {
                ...state,
                loading: false,
                regularizationigss: {
                    ...state.regularizationigss,
                    ...action.payload
                }
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF:
            return {
                ...state,
                loading: true,
                regularizationigsspdf: {
                    ...state.regularizationigsspdf
                }
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS:
            return {
                ...state,
                loading: false,
                regularizationigsspdf: {
                    ...state.regularizationigsspdf,
                    ...action.payload
                }
            }
        case INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case INDEX_PAYMENT_REPORT_DESTINATION:
            return {
                ...state,
                loading: true,
                destination: {
                    ...state.destination
                }
            }
        case INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS:
            return {
                ...state,
                loading: false,
                destination: {
                    ...state.destination,
                    ...action.payload
                }
            }
        case INDEX_PAYMENT_REPORT_DESTINATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};